/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { CreateDataListingChangeStateBadgeCell } from '@components-clean/core/grid/custom-cell/badge-cell';
import { ApiGridParams, ColumnDefinition } from '@interfaces/central-monitoring';

enum SubjectHubGridColumns {
    Tags = 'tags',
}

enum SiteSummaryGridColumns {
    PanelSiteScore = 'panel_site_score',
}

enum DataListingReviewGridColumns {
    State = 'state',
}

export class BaseGridHelper implements IGridHelper {
    private _gridParams: Extract<ApiGridParams, { grid: 'DataTable' }>;

    private _customCells: CustomCells;

    constructor(
        private gridParams: Extract<ApiGridParams, { grid: 'DataTable' }>,
        private customCells: CustomCells,
    ) {
        this._gridParams = gridParams;
        this._customCells = customCells;
    }

    getDisplayFields() {
        return true;
    }

    getActiveField() {
        return undefined;
    }

    getDisplayTooltipFields() {
        return false;
    }

    isRagColumn(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case SiteSummaryGridColumns.PanelSiteScore:
                return true;
            default:
                return false;
        }
    }

    disableLock() {
        return false;
    }

    multiValueFilter(columnType: ColumnDefinition) {
        return !!(this._gridParams.comparisonDatasetId && columnType.multiValueCell);
    }

    getColumnWidth() {
        return undefined;
    }

    getCustomCell(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case SiteSummaryGridColumns.PanelSiteScore:
                // Could potentially use the MultiValue cell instead of creating a new one,
                // but that feels like a bit of a misuse of the cell when this is 1 RAG Chip
                return this._customCells.RAGChipFieldCell(columnType.dataField, 'panel_site_rag');
            case DataListingReviewGridColumns.State:
                return CreateDataListingChangeStateBadgeCell();
            default:
                return undefined;
        }
    }

    disableAdvancedFilter() {
        return false;
    }

    lovMultiSelect(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case SubjectHubGridColumns.Tags:
                return true;

            default:
                return false;
        }
    }
}
